import React, { useContext, useEffect, useState, CSSProperties } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
// import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useMutation, useQuery } from "@apollo/client";
import { GET_USERS } from "./inboxes.query";
import AddInbox from "../../components/AddInbox/AddInbox";
import EditInboxName from "src/components/EditInboxName/EditInboxName";
import AddPrebuiltTemplate from "src/components/AddPrebuiltTemplate/AddPrebuiltTemplate";
import { ThemeContext } from "src/helpers/themeContext";
import SweetAlert from "react-bootstrap-sweetalert";
import { DELETE_INBOX } from "./deleteInboxQuery";
import { DELETE_API } from "./deleteAPIQuery";
import { DELETE_USER_INBOX } from "./deleteUserInbox";
import DeleteModal from "src/components/deleteModal/deleteModal";
import EditInbox from "src/components/EditInbox/EditInbox";
import "./Inboxes.scss";

interface TableData {
  Id: number | string;
  APIAccountId: number;
  OrgId: number;
  CreatedOn: string;
  OrgName: string;
  PhoneNumber: string;
  InboxName: string;
  IsPersonal: boolean;
}

const Inboxes = () => {
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [modal, setModal] = useState(false);
  const [templatesModal, setTemplatesModal] = useState(false);
  const [selectedInbox, setSelectedInbox] = useState<number>(-1);
  const [selectedApiAccountId, setSelectedApiAccountId] = useState<number>(-1);
  const [selectedOrgId, setSelectedOrgId] = useState<number>(-1);
  const [selectedOrgName, setSelectedOrgName] = useState<string>();
  const [editInboxModel, setEditInboxModel] = useState(false);
  const [PassedUser, setPassedUser] = useState<TableData | null>(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteModalData, setDeleteModalData] = useState<TableData | null>(
    null
  );
  const [dynamic_description, setdynamic_description] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [searchText, setSearchText] = useState("");
  const Theme = useContext(ThemeContext);
  const [deleteInbox] = useMutation(DELETE_INBOX);
  const [deleteUserInbox] = useMutation(DELETE_USER_INBOX);
  const [deleteAPI] = useMutation(DELETE_API);

  const columns = [
    {
      dataField: "Id",
      text: "ID",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "APIAccountId",
      text: "API Account ID",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "OrgId",
      text: "Org ID",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "InboxName",
      text: "Inbox Name",
      sort: true,
      headerStyle: { textAlign: "left" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "IsPersonal",
      text: "Is Personal",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cell: boolean) => (
        <div className="text-center">
          {cell ? (
            <i className="mdi mdi-check text-success font-size-18" />
          ) : (
            <i className="mdi mdi-close text-danger font-size-18" />
          )}
        </div>
      )
    },
    {
      dataField: "PhoneNumber",
      text: "Phone Number",
      sort: true,
      headerStyle: { textAlign: "left" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "OrgName",
      text: "Organization",
      sort: true,
      headerStyle: { textAlign: "left" } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "CreatedOn",
      text: "Created",
      sort: true,
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      sortFunc: (a: string, b: string, order: string) => {
        const dateA = parseDate(a);
        const dateB = parseDate(b);
        if (order === "asc") {
          return dateA - dateB;
        }
        return dateB - dateA;
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      text: "Action",
      headerStyle: { textAlign: "center" } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cellContent: any, user: TableData) => (
        <div className="d-flex justify-content-center">
          <UncontrolledDropdown>
            <DropdownToggle tag="button" className="btn btn-light btn-sm">
              <i className="uil uil-ellipsis-h"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem onClick={() => handleEdit(user)}>
                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                Edit Inbox
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  setDeleteModalData(user);
                  setDeleteModalOpen(true);
                }}
              >
                <i className="mdi mdi-delete font-size-16 me-1"></i>
                Delete Inbox
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      ),
    },
  ];

  const defaultSorted: any = [
    {
      dataField: "Id",
      order: "asc",
    },
  ];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
    firstPageText: "First",
    prePageText: "<",
    nextPageText: ">",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: (from: number, to: number, size: number) => {
      return (
        <span className="react-bootstrap-table-pagination-total">
          Showing {from} to {to} of {size} Results
        </span>
      );
    },
  };

  const parseDate = (dateStr: string): number => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day).getTime(); // month is 0-based
  };

  const { data, refetch } = useQuery(GET_USERS, { fetchPolicy: "no-cache" });

  useEffect(() => {
    if (data && data.msgbox_APIAccount) {
      var tmpData = data.msgbox_APIAccount
        .filter((item: any) => item.Organisation)
        .map(function (item: {
          APIAccountId: any;
          OrgId: any;
          InboxId: any;
          CreatedOn: string | number | Date;
          Organisation: { Name: any; OrganisationId: any };
          PhoneNumber: any;
          Inboxes: { Name: any; InboxId: number, IsPersonal: boolean }[];
        }) {
          return {
            Id: item.Inboxes[0] ? item.Inboxes[0].InboxId : "No inbox assigned",
            APIAccountId: item.APIAccountId,
            OrgId: item.Organisation.OrganisationId,
            CreatedOn: new Date(item.CreatedOn).toLocaleDateString(),
            OrgName: item.Organisation.Name,
            PhoneNumber: item.PhoneNumber,
            InboxName: item.Inboxes[0]
              ? item.Inboxes[0].Name
              : "No inbox assigned",
            IsPersonal: item.Inboxes[0] ? item.Inboxes[0].IsPersonal : false,
          };
        });
      setTableData(tmpData);
    }
  }, [data]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setSearchText(text);

    if (data && data.msgbox_APIAccount) {
      const filteredData = data.msgbox_APIAccount
        .filter((item: any) => item.Organisation)
        .filter((item: any) => {
          const searchStr = text.toLowerCase();
          return (
            (item.Inboxes[0]?.Name || "").toLowerCase().includes(searchStr) ||
            (item.PhoneNumber || "").toLowerCase().includes(searchStr) ||
            (item.Organisation.Name || "").toLowerCase().includes(searchStr)
          );
        })
        .map(function (item: any) {
          return {
            Id: item.Inboxes[0] ? item.Inboxes[0].InboxId : "No inbox assigned",
            APIAccountId: item.APIAccountId,
            OrgId: item.Organisation.OrganisationId,
            CreatedOn: new Date(item.CreatedOn).toLocaleDateString(),
            OrgName: item.Organisation.Name,
            PhoneNumber: item.PhoneNumber,
            InboxName: item.Inboxes[0]
              ? item.Inboxes[0].Name
              : "No inbox assigned",
            IsPersonal: item.Inboxes[0] ? item.Inboxes[0].IsPersonal : false,
          };
        });
      setTableData(filteredData);
    }
  };

  // handle Inbox Rename
  const handleEdit = (user: TableData) => {
    console.log("Opening EditInbox for user:", user);
    console.log("User IsPersonal:", user.IsPersonal);
    setSelectedOrgName(user.OrgName);
    setSelectedInbox(
      typeof user.Id === "string" ? parseInt(user.Id, 10) : user.Id
    );
    setPassedUser(user);
    toggleRename();
  };
  const toggleRename = () => {
    setEditInboxModel(!editInboxModel);
  };

  //handle AddInbox
  const toggleAddInboxModal = () => {
    setModal(!modal);
  };

  const handleUserClicks = () => {
    toggleAddInboxModal();
  };

  const handleAddTemplatesClicked = (data: any) => {
    console.log("data:", data);
    setSelectedInbox(data.Id);
    setSelectedOrgId(data.OrgId);
    setSelectedOrgName(data.OrgName);
    setSelectedApiAccountId(data.APIAccountId);
    setTemplatesModal(!templatesModal);
  };

  const handleDelete = async (user: TableData) => {
    setDeleteModalOpen(false);
    await deleteInbox({
      variables: {
        InboxId: user.Id,
        userId: localStorage.getItem("user_id"),
        time: new Date(Date.now()).toISOString(),
      },
    });

    const bytes = crypto.getRandomValues(new Uint8Array(20));
    const randomString = new TextDecoder().decode(bytes);

    await deleteAPI({
      variables: {
        apiId: user.APIAccountId,
        userId: localStorage.getItem("user_id"),
        time: new Date(Date.now()).toISOString(),
        phoneNumber: randomString,
      },
    });

    await deleteUserInbox({
      variables: {
        InboxId: user.Id,
        userId: localStorage.getItem("user_id"),
        time: new Date(Date.now()).toISOString(),
      },
    });

    setsuccess_dlg(true);
    setdynamic_description(
      "Item will not be available to the user now, it will be permanently deleted in 60 days"
    );
    refetch();
  };

  const refetchData = () => {
    refetch();
  };

  return (
    <React.Fragment>
      {success_dlg && (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      )}

      <DeleteModal
        isOpen={deleteModalOpen}
        cancel={() => setDeleteModalOpen(false)}
        submit={() => deleteModalData && handleDelete(deleteModalData)}
      />

      <div className="mb-2">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">All Inboxes</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={handleUserClicks}
                  >
                    <i className="uil uil-plus me-1"></i>
                    Add Inbox
                  </button>
                </div>
              </CardHeader>
              <CardBody>
                <PaginationProvider pagination={paginationFactory(pageOptions)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <React.Fragment>
                      <Row>
                        <Col xl="12">
                          <div className="search-box me-2">
                            <div className="position-relative">
                              <Input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                value={searchText}
                                onChange={handleSearch}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              classes="table align-middle table-nowrap"
                              headerWrapperClasses="thead-dark"
                              headerClasses="table-dark"
                              {...paginationTableProps}
                              keyField="Id"
                              columns={columns}
                              data={tableData}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline">
                            <SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                          </div>
                          <div className="text-md-right ms-auto">
                            <PaginationListStandalone {...paginationProps} />
                          </div>
                        </Col>
                      </Row>
                    </React.Fragment>
                  )}
                </PaginationProvider>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <AddInbox modal={modal} setModal={setModal} onRefetch={refetchData} />

        <EditInbox
          modal={editInboxModel}
          setModal={setEditInboxModel}
          onRefetch={refetchData}
          inboxId={selectedInbox}
          orgName={selectedOrgName}
        />

        <AddPrebuiltTemplate
          modal={templatesModal}
          setModal={setTemplatesModal}
          onRefetch={refetchData}
          inboxId={selectedInbox}
          orgId={selectedOrgId}
          orgName={selectedOrgName}
          apiAccountId={selectedApiAccountId}
        />
      </div>
    </React.Fragment>
  );
};

export default Inboxes;
